export const SET_DISCOUNTED_CASH_FLOW_METHOD = "SET_DISCOUNTED_CASH_FLOW_METHOD"